import { JobPriorityType, JobStatusNewType, JobType } from '@/enum'
import type {
  IAssignedEmployee,
  IJob,
  IJobAssociatedAsset,
  IJobAssociatedAssetInfo,
  IJobAssociatedMaintenanceType,
  IJobAssociatedTaskTemplate,
  IJobSchedule,
  INextTriggerInfo,
  IVendor
} from '@/interfaces'
import type { IDocument } from '@/interfaces/IDocument'
import Base from '../Base'
import DocumentModel from '../DocumentModel'
import JobAssociatedAsset from './JobAssociatedAsset'
import JobAssociatedAssetInfo from './JobAssociatedAssetInfo'
import JobAssociatedTaskTemplate from './JobAssociatedTaskTemplate'
import JobSchedule from './JobSchedule'
import type { IAppUser } from '@/interfaces/app-user/IAppUser'
import AppUser from '../AppUser'
import { Vendor } from '../vendors'
import AssignedEmployee from '../employees/AssignedEmployee'
import NextTriggerInfo from './NextTriggerInfo'

class Job extends Base implements IJob {
  title: string
  number: string
  description?: string
  type?: JobType
  asset?: IJobAssociatedAsset
  assetInfo?: IJobAssociatedAssetInfo
  status: JobStatusNewType
  priority?: JobPriorityType
  scheduledAt?: string
  dueAt?: string
  startedAt?: string
  completedAt?: string
  closedAt?: string
  issueReporterId?: string
  issueReporter?: IAppUser
  assignedEmployeeIds?: string[]
  employees?: IAssignedEmployee[]
  workOrderVendorId?: string
  workOrderVendor?: IVendor
  workOrderUrl?: string
  maintenanceTypes?: IJobAssociatedMaintenanceType[]
  taskTemplates?: IJobAssociatedTaskTemplate[]
  documents?: IDocument[]
  enforceSequentialTaskCompletion?: boolean
  schedule: IJobSchedule
  nextTriggerInfo?: INextTriggerInfo

  constructor(job?: any) {
    super(job)
    this.title = job?.title ?? null
    this.number = job?.number
    this.description = job?.description ?? null
    this.type = job?.type
    if (job?.asset) {
      this.asset = new JobAssociatedAsset(job?.asset)
    }
    if (job?.assetInfo) {
      this.assetInfo = new JobAssociatedAssetInfo(job?.assetInfo)
    }
    this.status = job?.status ?? null
    this.priority = job?.priority ?? null
    this.scheduledAt = job?.scheduledAt
    this.dueAt = job?.dueAt
    this.startedAt = job?.startedAt
    this.completedAt = job?.completedAt
    this.closedAt = job?.closedAt
    this.issueReporterId = job?.issueReporterId
    this.issueReporter = new AppUser(job?.issueReporter)
    this.assignedEmployeeIds = job?.assignedEmployeeIds
    this.employees = job?.employees.map((employee: any) => new AssignedEmployee(employee))
    this.workOrderVendorId = job?.workOrderVendorId
    this.workOrderVendor = new Vendor(job?.workOrderVendor)
    this.workOrderUrl = job?.workOrderUrl
    this.maintenanceTypes = job?.maintenanceTypes
    this.taskTemplates = job?.taskTemplates?.map(
      (taskTemplate: any) => new JobAssociatedTaskTemplate(taskTemplate)
    )
    this.documents = job?.documents?.map((document: any) => new DocumentModel(document))
    this.enforceSequentialTaskCompletion = job?.enforceSequentialTaskCompletion
    this.schedule = new JobSchedule(job?.schedule)
    this.nextTriggerInfo = new NextTriggerInfo(job?.nextTriggerInfo)
  }
}

export default Job
